var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center p-10"},[_c('a',{attrs:{"tabindex":"0","href":"https://poznejho.cz/#Contact__1"}},[_vm._v(_vm._s(_vm.$t('pages.support_us')))])])}
var staticRenderFns = []

export { render, staticRenderFns }